import { Component, model } from '@angular/core';
import { GalleriaModule } from 'primeng/galleria';
@Component({
  selector: 'app-galleria',
  imports: [GalleriaModule],
  template: `
    <p-galleria
      [value]="images()"
      [(visible)]="visible"
      [containerStyle]="{ margin: '200px' }"
      [numVisible]="7"
      [circular]="true"
      [fullScreen]="true"
      [showItemNavigators]="showItemNavigators"
      [showIndicatorsOnItem]="showItemNavigators"
      [showThumbnails]="false"
      [responsiveOptions]="[]"
    >
      <ng-template #item let-item>
        <img
          [src]="item.src"
          style="height: 850px; display: block;margin: 60px;"
          alt="Preview image"
        />
      </ng-template>
    </p-galleria>
  `,
  styles: ``,
})
export class GalleriaComponent {
  visible = false;

  images = model<GalleriaImage[]>([]);

  showItemNavigators = false;

  // responsiveOptions: any[] = [
  //   {
  //     breakpoint: '1500px',
  //     numVisible: 5,
  //   },
  //   {
  //     breakpoint: '1024px',
  //     numVisible: 3,
  //   },
  //   {
  //     breakpoint: '768px',
  //     numVisible: 2,
  //   },
  //   {
  //     breakpoint: '560px',
  //     numVisible: 1,
  //   },
  // ];

  show(images: GalleriaImage[]) {
    this.visible = true;
    this.showItemNavigators = images.length > 1;
    this.images.set(images);
  }
}

export class GalleriaImage {
  src: string;
  thumbnailSrc?: string;
  title?: string;
  alt?: string;
}
